import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=fd5c464c&lang=pug&"
import script from "./UiButton.vue?vue&type=script&lang=ts&"
export * from "./UiButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports